import React from "react";

function Title({item,clinicName}:any) {

  return (
    <p
      style={{
        position: "absolute",
        top: item?.top,
        left: item?.left,
        fontSize: item?.size,
        display: item?.show ? "" : "none",
        textTransform:"uppercase",
        fontWeight:600,
        
      }}
    >
      {clinicName}
    </p>
  );
}

export default Title;
